import { makeStyles } from '@rbx/ui';

const useRegeneratedResponseHeaderStyles = makeStyles()(() => ({
  header: {
    fontWeight: 500,
  },
}));

export default useRegeneratedResponseHeaderStyles;
